import { BinderNote } from '@/models/binder.model';
import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BinderNotesService {
  private baseUrl = environment.landmark_API_URL + '/notes';

  selectedNote = signal<BinderNote | null>(null);
  loadingNotes = signal<boolean>(false);

  notes = signal<BinderNote[]>([]);

  constructor(private http: HttpClient) {
  }

  setSelectedNote(note: BinderNote) {
    this.selectedNote.set(note);
  }

  unselectNote() {
    this.selectedNote.set(null);
  }

  getSelectedNote() {
    return this.selectedNote();
  }

  getNotes(binderId: number) {
    this.loadingNotes.set(true);
    this.http.get<BinderNote[]>(this.baseUrl + `/${binderId}`).subscribe((notes) => {
      this.notes.set(notes);
      this.loadingNotes.set(false);
    });
  }

  createNote(note: Partial<BinderNote>) {
    this.http.post<BinderNote>(this.baseUrl, note).subscribe((note) => {
      this.notes.set(this.notes().concat(note));
    });
  }

  updateNote(note: Partial<BinderNote>) {
    this.http.put<BinderNote>(this.baseUrl, note).subscribe((note) => {
      this.notes.set(this.notes().map((n) => n.BNoteID === note.BNoteID ? note : n));
    });
  }

  deleteNote(noteId: number) {
    this.http.delete<BinderNote>(`${this.baseUrl}/${noteId}`).subscribe((note) => {
      this.notes.set(this.notes().filter((n) => n.BNoteID !== noteId));
    });
  }
  
  
  

}
